"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SecureChannel_1 = __importDefault(require("./uasc/SecureChannel"));
class Client extends EventTarget {
    constructor() {
        super();
        this.secureChannel = new SecureChannel_1.default();
        this.secureChannel.addEventListener('session:activate', event => {
            this.dispatchEvent(new Event(event.type));
        });
    }
    browse(req) {
        console.log(req);
        return new Promise(resolve => {
            // resolve()
            this.secureChannel.send(req, resolve);
        });
    }
}
exports.default = Client;
